import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Suspense, ReactElement } from 'react';
import { Loader } from '@components';
import { RoutesMap } from './Definitions';
import { Panel } from '@pages/Panel/Panel';
import { useAuth } from '@providers/Auth';
import { useMsal } from '@azure/msal-react';

function ProtectedRoute({ children }: { children: ReactElement }) {
  const { user } = useAuth();

  if (!user || user.foundation.status !== 'ACTIVE') {
    return <Navigate to="/" replace />;
  }

  return children;
}

function PublicRoute({ children }: { children: ReactElement }) {
  const { instance } = useMsal();
  const accounts = instance.getAllAccounts();
  const { pathname } = useLocation();
  const isRegisterRoute = pathname === '/registros';

  if (isRegisterRoute && !accounts.length) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export function Router() {
  const { user } = useAuth();

  const foundationType = user?.foundation.type;
  const foundationActive = user?.foundation.status === 'ACTIVE';
  const appRoutes = foundationType ? RoutesMap[foundationType as keyof typeof RoutesMap] : [];

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {RoutesMap.HOME.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <PublicRoute>
                <route.element />
              </PublicRoute>
            }
          />
        ))}
        {RoutesMap.AUTH.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <PublicRoute>
                <route.element />
              </PublicRoute>
            }
          />
        ))}
        {appRoutes.map((route) => (
          <Route
            key={`app-${route.path}`}
            path={route.path}
            element={
              <ProtectedRoute>
                <Panel>
                  <route.element />
                </Panel>
              </ProtectedRoute>
            }
          />
        ))}
        <Route path="*" element={<Navigate to={foundationActive ? '/painel' : '/'} replace />} />
      </Routes>
    </Suspense>
  );
}
